import { render, staticRenderFns } from "./LockerDeliveryStatus.vue?vue&type=template&id=5c9b5452&scoped=true"
import script from "./LockerDeliveryStatus.vue?vue&type=script&lang=js"
export * from "./LockerDeliveryStatus.vue?vue&type=script&lang=js"
import style0 from "./LockerDeliveryStatus.vue?vue&type=style&index=0&id=5c9b5452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b5452",
  null
  
)

export default component.exports